import {
  createResource,
  postResource,
  deleteResource,
  postFormDataPrettifierResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'ticket/'

const ADD_TICKET_URL = prefixAPI('create/', MODEL)
const TICKET_LIST_URL = prefixAPI('list/{?limit,offset,filters*}', MODEL)
const TICKET_FILTERS_LIST_URL = prefixAPI('filters/', MODEL)
const TICKET_MESSAGES_LIST_URL = prefixAPI('message/list/{?ticket}', MODEL)
const TICKET_DETAIL_URL = prefixAPI('retrieve/{id}/', MODEL)
export const TICKET_TYPE_OF_APPEAL_LIST_URL = prefixAPI('type-of-appeal/list/', MODEL)
export const TICKET_SUBJECT_OF_APPEAL_LIST_URL = prefixAPI('subject-of-appeal/list/{?types}', MODEL)
export const TICKET_FEEDBACK_METHOD_LIST_URL = prefixAPI('feedback-method/list/', MODEL)
const TICKET_FILE_CREATE_URL = prefixAPI('file-storage/create/', MODEL)
const TICKET_FILE_DELETE_URL = prefixAPI('file-storage/delete/{id}/', MODEL)

export const createTicket = createResource(
  ADD_TICKET_URL, postResource
)
export const createTicketFile = createResource(
  TICKET_FILE_CREATE_URL, postFormDataPrettifierResource
)
export const removeTicketFile = createResource(
  TICKET_FILE_DELETE_URL, deleteResource
)
export const getTicketList = createResource(TICKET_LIST_URL)
export const getTicketMessagesList = createResource(TICKET_MESSAGES_LIST_URL)
export const getTicketDetail = createResource(TICKET_DETAIL_URL)
export const getTicketFiltersList = createResource(TICKET_FILTERS_LIST_URL)
export const getFeedbackMethods = createResource(TICKET_FEEDBACK_METHOD_LIST_URL)
export const getTypeOfAppeals = createResource(TICKET_TYPE_OF_APPEAL_LIST_URL)
